import { subcategories } from "@aclymatepackages/subcategories";

export const scopeThreeSpendBasedCategories = subcategories.filter(
  ({ category }) => category === "Scope Three Category"
);

// The fifteen GHG Protocol Scope 3 categories in standard order, using the category names from the
// Corporate Value Chain (Scope 3) Standard. Aclymate calculates a subset of these. The remainder are
// reported as "not calculated" rather than omitted from the report, so that a category we never
// evaluated is never presented to a customer's customer as a zero.
export const ghgProtocolScopeThreeCategories = [
  { scopeThreeCategory: 1, name: "Purchased Goods and Services" },
  { scopeThreeCategory: 2, name: "Capital Goods" },
  {
    scopeThreeCategory: 3,
    name: "Fuel and Energy Related Activities Not Included in Scope 1 or Scope 2"
  },
  { scopeThreeCategory: 4, name: "Upstream Transportation and Distribution" },
  { scopeThreeCategory: 5, name: "Waste Generated in Operations" },
  { scopeThreeCategory: 6, name: "Business Travel" },
  { scopeThreeCategory: 7, name: "Employee Commuting" },
  { scopeThreeCategory: 8, name: "Upstream Leased Assets" },
  { scopeThreeCategory: 9, name: "Downstream Transportation and Distribution" },
  { scopeThreeCategory: 10, name: "Processing of Sold Products" },
  { scopeThreeCategory: 11, name: "Use of Sold Products" },
  { scopeThreeCategory: 12, name: "End of Life Treatment of Sold Products" },
  { scopeThreeCategory: 13, name: "Downstream Leased Assets" },
  { scopeThreeCategory: 14, name: "Franchises" },
  { scopeThreeCategory: 15, name: "Investments" }
];

export const scopeThreeCategoryStatusLabels = {
  calculated: "Calculated",
  notCalculated: "Not calculated"
};

// Merges the standard category list with Aclymate's spend-based categories so the report can resolve
// each category to its subcategory key. A category with no matching subcategory isn't supported by
// Aclymate today and is always reported as not calculated.
export const buildReportScopeThreeCategories = () =>
  ghgProtocolScopeThreeCategories.map((category) => {
    const match = scopeThreeSpendBasedCategories.find(
      ({ scopeThreeCategory }) =>
        scopeThreeCategory === category.scopeThreeCategory
    );

    return {
      ...category,
      subcategory: match?.subcategory || null,
      isSupported: !!match
    };
  });
